import React from "react";
import { Col, Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { TitleContainer } from "./elements";

interface TableTitleProps {
  setNameFilter: (value: string) => void;
  setShowCreateModal: (value: boolean) => void;
  setShowPriorityModal: (value: boolean) => void;
}

const TableTitle: React.FC<TableTitleProps> = ({ setNameFilter, setShowCreateModal, setShowPriorityModal }) => {
  return (
    <div>
      <TitleContainer>
        <Col span={24} style={{ display: "flex",
          justifyContent: "space-between",
          alignItems: "center" }}>
          <Input
            style={{ width: 250 }}
            placeholder="Buscar por nombre"
            allowClear
            onChange={(e) => setNameFilter(e.target.value)}
          />
          <div style={{ display: "flex",
            gap: "10px" }}>
            <Button
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() => {
                setShowPriorityModal(true);
              }}
            >
              Ordenar Categorias
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setShowCreateModal(true);
              }}
            >
              Crear Categoria
            </Button>
          </div>
        </Col>
      </TitleContainer>
    </div>
  );
};

export default TableTitle;
